// (c) 2020, SAS Institute Inc.

// Common header names to prevent magic strings in code.

export enum HeaderName {
  Accept = 'Accept',
  AcceptItem = 'Accept-Item',
  ContentType = 'Content-Type',
  ETag = 'ETag',
  IfMatch = 'If-Match',
  IfModifiedSince = 'If-Modified-Since',
  IfNoneMatch = 'If-None-Match',
  IfUnmodifiedSince = 'If-Unmodified-Since',
  RequestedWith = 'X-Requested-With',
  SASRequest = 'SAS-Request',
  UnauthorizedReason = 'X-Unauthorized-Reason',
}
